import Month from "@/models/Shared/Month";

export default (month: Month) => {
    let returnVal = "Undefined";
    switch (month) {
        case Month.January: {
            returnVal = "January"
            break;
        }
        case Month.February: {
            returnVal = "February"
            break;
        }
        case Month.March: {
            returnVal = "March"
            break;
        }
        case Month.April: {
            returnVal = "April"
            break;
        }
        case Month.May: {
            returnVal = "May"
            break;
        }
        case Month.June: {
            returnVal = "June"
            break;
        }
        case Month.July: {
            returnVal = "July"
            break;
        }
        case Month.August: {
            returnVal = "August"
            break;
        }
        case Month.September: {
            returnVal = "September"
            break;
        }
        case Month.October: {
            returnVal = "October"
            break;
        }
        case Month.November: {
            returnVal = "November"
            break;
        }
        case Month.December: {
            returnVal = "December"
            break;
        }

    }
    return returnVal;
}